// import './App.css'
// import Pages from "@/pages/index.jsx"
// import { Toaster } from "react-hot-toast";
// import { AuthProvider } from "@/auth/AuthContext" // <--- הוסף את הייבוא (וודא שהנתיב נכון)
// import InstallBanner from "@/pages/InstallBanner.jsx";

// // 1. הוספת הייבוא של React Query
// import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

// // 2. יצירת מופע של ה-Client
// const queryClient = new QueryClient()

// function App() {
//   return (
//     // 3. עטיפת האפליקציה בספק של React Query
//     <QueryClientProvider client={queryClient}>
//       <AuthProvider>
//         <Pages />
//         <Toaster position="top-center" reverseOrder={false} />
//         <InstallBanner />
//       </AuthProvider>
//     </QueryClientProvider>
//   )
// }

// export default App






import './App.css'
import Pages from "@/pages/index.jsx"
import { Toaster } from "react-hot-toast";
import { AuthProvider } from "@/auth/AuthContext"
import { LocalStoreProvider } from "@/contexts/LocalStoreContext"
import InstallBanner from "@/pages/InstallBanner.jsx";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import * as Sentry from "@sentry/react"

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  },
})

function App() {
  return (
    <Sentry.ErrorBoundary
      fallback={
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h1>אופס, משהו השתבש</h1>
          <p>הודעה נשלחה למפתחים. נסה לרענן את הדף.</p>
          <button onClick={() => {
            if (typeof navigator !== 'undefined' && navigator.onLine) {
              window.location.reload();
            }
          }}>רענן עכשיו</button>
          {typeof navigator !== 'undefined' && !navigator.onLine && (
            <p style={{ marginTop: 8, color: '#666' }}>אין חיבור לאינטרנט — רענון זמין רק כשחוזר החיבור.</p>
          )}
        </div>
      }
    >
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <LocalStoreProvider>
            <Pages />
            <Toaster position="top-center" reverseOrder={false} />
            <InstallBanner />
          </LocalStoreProvider>
        </AuthProvider>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  )
}

export default App